import { CookieCategory, onCookieConsent } from 'modules/helpers/cookieInformationHelper';
import WebsiteSettings from 'modules/websiteSettings';
import initZowie from './zowie';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { removeButtonStyling } from 'modules/helpers/mixins';
import CookieInfobox from 'components/CookieInfobox';
import { BoxShadowLarge } from 'autogen/design-tokens/tokens';
import { Button } from 'components/Button';
import Icon from 'components/Icon';
import { useTranslation } from 'react-i18next';
import type { TFunctionNonStrict } from 'i18next';
import {
    AcceptMarketingCookiesToSeeElementBody,
    ChatNotAllowed,
    Close
} from 'autogen/translation-keys/trans-website-shared';
import Zowie from './Zowie.svg?react';
import { CustomerServiceButton } from 'autogen/translation-keys/trans-website-chat';

const ZowieCookieButtonWrapper = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: end;
    bottom: 25px;
    right: 25px;
    z-index: 30001;
    gap: ${({ theme }) => theme.Spacing8};
`;

const CoookieButton = styled.button`
    ${removeButtonStyling}
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 40px;
    border-radius: 8px;
    cursor: pointer;
    width: 60px;
    height: 60px;
    opacity: 1;
    transition: opacity 0.3s linear 0.1s;
    @starting-style {
        opacity: 0;
    }
`;

const CookieBoxWrapper = styled.div`
    box-shadow: ${BoxShadowLarge};
    border-radius: ${({ theme }) => theme.RadiusMedium};
    position: relative;
`;

const CookieBoxCloseButton = styled(Button)`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
`;

const renderCookieButton = (t: TFunctionNonStrict) => {
    const [showCookieOverlay, setShowCookieOverlay] = useState(false);
    const onCookieButtonClick = () => {
        setShowCookieOverlay(true);
    };

    return (
        <ZowieCookieButtonWrapper>
            {showCookieOverlay && (
                <CookieBoxWrapper>
                    <CookieBoxCloseButton
                        variant="ghost"
                        size="sm"
                        onClick={() => setShowCookieOverlay(false)}
                        aria-label={t(Close)}
                    >
                        <Icon type="Close" size={16} />
                    </CookieBoxCloseButton>
                    <CookieInfobox
                        callback={() => setShowCookieOverlay(false)}
                        headline={t(ChatNotAllowed)}
                        body={t(AcceptMarketingCookiesToSeeElementBody)}
                    />
                </CookieBoxWrapper>
            )}
            <CoookieButton onClick={onCookieButtonClick} aria-label={t(CustomerServiceButton)}>
                <Zowie />
            </CoookieButton>
        </ZowieCookieButtonWrapper>
    );
};

const ZowieRenderer = () => {
    const { isZowieEnabled } = WebsiteSettings.liveChat;
    if (!isZowieEnabled) return null;

    const [cookieConsent, setCookieConsent] = useState(false);
    const { t } = useTranslation();

    // biome-ignore lint/correctness/useExhaustiveDependencies: Only run once on mount
    useEffect(() => {
        if (isZowieEnabled) {
            onCookieConsent(CookieCategory.marketing).then((granted) => {
                setCookieConsent(granted);
                if (granted) {
                    initZowie();
                }
            });
        }
    }, []);

    return isZowieEnabled && !cookieConsent && renderCookieButton(t);
};

export default ZowieRenderer;
